/* eslint-disable no-continue */
import { createSelector } from '@reduxjs/toolkit';

import { defaultSorterTypes, HabitatSortType, sortHabitats } from '@/helpers/habitatsSorter';
import { HabitatListItem } from '@/queries/habitats/types';

import { AppState } from '../helper';
import { selectHasExplorerFeature } from './users';

// eslint-disable-next-line import/prefer-default-export -- shared named export used across the app
export const createSortedHabitatsSelector = (
  sorterTypes: readonly HabitatSortType<HabitatListItem>[] = defaultSorterTypes,
) =>
  createSelector(
    (state: AppState) => state.allHabitats,
    selectHasExplorerFeature,
    (state: AppState) => state.remoteConfig.lastMediaCaptureThresholdForFeaturedHabitatMinutes,
    (state: AppState) => state.user.subscription.habitatsAccessUntil,
    (allHabitats, hasExplorerFeature, threshold, habitatsAccessUntil) => {
      const sorted = sortHabitats(allHabitats, sorterTypes, threshold);
      return sorted.map((habitat) => ({
        ...habitat,
        isLocked:
          !hasExplorerFeature &&
          !(habitatsAccessUntil?.[habitat._id] && Date.parse(habitatsAccessUntil[habitat._id]) > Date.now()),
      }));
    },
  );

export const selectHabitatsByZooId = createSelector(
  createSortedHabitatsSelector(),
  (_: AppState, zooId: string) => zooId,
  (allHabitats, zooId) => allHabitats.filter((habitat) => habitat.zoo._id === zooId),
);

export const selectHabitatIdsByZooId = createSelector(
  createSortedHabitatsSelector(),
  (_: AppState, zooId: string) => zooId,
  (allHabitats, zooId) => allHabitats.filter((habitat) => habitat.zoo._id === zooId).map((habitat) => habitat._id),
);

export const selectZoosFromHabitats = createSelector(
  (state: AppState) => state.allHabitats,
  (habitats) => Array.from(new Map(habitats.map((habitat) => [habitat.zoo._id, habitat.zoo])).values()),
);
